import QRCode from 'qrcode'
import * as  jsPDF from 'jspdf';


/// TO print cartonslip on secondary packing service
export default class PrintSecondaryPackagingManualService {

    genQR(text) {
        let qr = "";
        QRCode.toDataURL(text, function (err, url) {
            qr = url;
        });
        return qr;
    }
    async formPreview1(resp) {
        debugger
        let doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [130, 110],
            compressPdf: true
        });

       
        const fromNo = resp[0].FromNo; // Get FromNo from the first item in resp
        const toNo = resp[0].ToNo;
       
        debugger;
        const fromNoLast4Digits = fromNo.substr(-4); // Extract last 4 digits from FromNo
        const toNoLast4Digits = toNo.substr(-4);
        for (let i = fromNo; i <= toNo; i++) {
            const Qr= `http://qr.tropicalagro.com/di-details?${resp[0].Plant}-${i}`
            //  const Qr= `http://104.211.167.63:5166/di-details?${resp[0].Plant}-${i}`
            debugger
            const qrdata = await this.genQR(Qr);
           
            doc.setFontType('bold');
            doc.setFont('Times');


          
            doc.setFontSize(6); // Set the font size for the heading
            doc.text('PACKING SLIP', 15, 2); // Add the heading "Packing Slip"

            doc.addImage(qrdata, 'JPEG', 1, 15, 20, 20); // Move the addImage to the left

            doc.setFontSize(7);
            doc.text(resp[0].ProductName, 2, 6);
            doc.setFontSize(6); // Move ProductName below the heading with reduced spacing
            doc.text('Batch No: ' + resp[0].BatchNo, 2, 9); // Put BatchNo below ProductName with reduced spacing
            doc.text('Mfg Dt: ' + resp[0].ManufactureDate, 2, 12);
            doc.text('Exp Dt: ' + resp[0].ExpiryDate, 2, 15);
            doc.text('G.W: ' + resp[0].GW, 21, 18);
            doc.text('Contractor:' + resp[0].Contractor, 21, 22);
            doc.text('Supervisor:' + resp[0].Supervisor, 21, 26);
            doc.text('Dt. of Pack:' + resp[0].DateOfPack, 21, 30);
            // doc.setFontSize(5);
            //  doc.text('Sale for: ' + 'For Sale in Haryana' , 18, 37);
            // doc.text('Contractor:' , 21, 22);
            // doc.text('Supervisor:' , 21, 26);
            // doc.text('Dt. of Pack:' , 21, 30);
            doc.setFontSize(6);
            doc.text(`${i}`, 2, 37); // Adjust position of other text as needed

            if (i < toNo) {
                doc.addPage();
            }
        }
        doc.save(resp[0].FromNo + - + resp[0].ToNo + '.pdf');
        //doc.save(`${resp[0].fromNo}-{resp[0].toNo}.pdf`);
    }
}